import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BANKRUPTCY_RISK_SCORE_API_SERVICE_TOKEN } from '@nk/api-lib';
import { CompanyRiskScoreGroupingEntity } from '@nk/data-entities-lib';
import { HelpPopoverComponent, PercentagePipe } from '@nk/ui-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BankruptcyRiskScoreLevelItemComponent } from '../bankruptcy-risk-score-level-item/bankruptcy-risk-score-level-item.component';

@Component({
  selector: 'nk-bankruptcy-risk-score-help-info',
  templateUrl: './bankruptcy-risk-score-help-info.component.html',
  styleUrls: ['./bankruptcy-risk-score-help-info.component.scss'],
  imports: [AsyncPipe, TranslateModule, PercentagePipe, HelpPopoverComponent, BankruptcyRiskScoreLevelItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BankruptcyRiskScoreHelpInfoComponent implements OnInit {
  public companyRiskScoreGroupingList$!: Observable<CompanyRiskScoreGroupingEntity[]>;

  public modelKey = input<string | null | undefined>();

  private _bankruptcyRiskScoreService = inject(BANKRUPTCY_RISK_SCORE_API_SERVICE_TOKEN);

  public ngOnInit(): void {
    this.companyRiskScoreGroupingList$ = this._bankruptcyRiskScoreService.companyRiskScoreGroupingListCache.get().pipe(
      map((list) =>
        [...list].sort((a, b) => {
          // Keep the "unset" group at the bottom, otherwise sort by risk descending.
          if (a.group_key === 'unset') {
            return 1;
          }
          if (b.group_key === 'unset') {
            return -1;
          }
          return (b.from_measure_value ?? -Infinity) - (a.from_measure_value ?? -Infinity);
        }),
      ),
    );
  }
}
